import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  HostListener,
  ViewChild,
  OnDestroy,
  OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import { AppService } from '@irb/app.service';
import { IrbEditorsService } from '@irb/irb-editors/irb-editors.service';
import { BlendedModelsAllocationService } from '@irb/irb-editors/editor-blended-model/blended-models-allocation.service';
import { CalltoactionService } from '@irb-common/components/calltoaction/calltoaction.service';
import { IrbAppEvents } from '@irb/app.events';
import { Subscription } from 'rxjs';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {CellClickedEvent} from "ag-grid-community";
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';


@Component({ standalone: false,
  selector: 'irb-blended-models-allocation',
  templateUrl: './blended-models-allocation.component.html',
  styleUrls: ['./blended-models-allocation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class BlendedModelsAllocationComponent implements OnInit, OnDestroy, OnChanges {

  rowCount: number = 0;
  grid: any;
  gridOptions: any;
  height: string = "200px";
  detailCellRendererParams: any;
  totalPercent: any;
  finScore: string = '--';
  finscoreToolTip: string = '';
  securityModelsList: Array<any> = [];
  private securityModelsListOriginal: Array<any> = [];
  private globSetSub: Subscription;
  upDateModel: any

  @Input()
  data: any;

  @Input() mmcModelIds: any;

  @Output() change = new EventEmitter<boolean>();
  @ViewChild('securityModelsDropdown') securityModelsDropdown: any;
  isUiTest = false;
  frameworkComponents: any;

  constructor(private as: AppService,
              public ies: IrbEditorsService,
              private bmas: BlendedModelsAllocationService,
              private ctas: CalltoactionService,
              private ats: AnalyticsService) {
    this.gridOptions = {
      columnDefs: this.bmas.getModelsColumnDefs(this),      
      context: {componentParent: this, parentId: 'edit-blended-model-allocation-grid'},
      embedFullWidthRows: true,
      floatingFilter: false,
      treeData: true,
      getDataPath: (data: any) => {
        const isChild: boolean = data.securityId ? true : false;
        return (isChild) ? [data.securityModelId.toString(), data.securityId.toString()] : [data.securityModelId.toString()];
      },
      treeDataDisplayType: 'custom',
      onRowGroupOpened: () => {
        this.setHeight();
      },
      onCellClicked:  this.onModelAllocationsGridCellClicked.bind(this)
    };
    
    this.frameworkComponents = this.bmas.getFrameworkComponents();
    this.finscoreToolTip = this.ies.finMansonTooltip();
  }

  setHeight() {
    setTimeout(() => {
      const gridEl: any = document.querySelector("#edit-blended-model-allocation-grid ag-grid-angular .ag-center-cols-clipper");
      if (gridEl) {
        let rowCount = 0;
        if (this.grid && this.grid.api) {
          this.grid.api.forEachNode((n: any) => {
            if (n.data.noSecurities) {
              rowCount++;
            }
            if (n.expanded) {
              rowCount += n.data.noSecurities;
            }
          });
        }
          rowCount = rowCount === 0 ? 1 : rowCount;
        let ht = rowCount * 30 + 65;
        ht = ht > 370 ? 370 : ht;

          this.height = ht + 'px';
          if (!this.isUiTest) {
            setTimeout(() => {
              this.setTotalPercent();
            }, 50);
          }

      }
      // if (this.grid && this.grid.api) {
      //   this.grid.api.sizeColumnsToFit();
      // }
    }, 100);
  }

  ngOnInit(): void {
    this.getSecurityModelDropDownForBlended();

    if (this.mmcModelIds) {
      this.mmcModelIds.forEach((modelId: any) => {
        const m: any = {value: modelId};
        this.securityModelsList.push(m);
      });
      this.addModelsFromDropdown();
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && this.grid) {
        this.load();
      this.finScore = this.data.finscore ? this.data.finscore : '--';
    }
  }

  private getAndUpdateCategoryLabel() {
    let globSet = this.bmas.getGlobalSettingValues();
    if (globSet) {
      this.updateCategoryLabel(globSet);
    } else {
      this.globSetSub = this.bmas.globalSettingsSubject.subscribe(() => {
        this.updateCategoryLabel(this.bmas.getGlobalSettingValues());
      });
    }
  }
  updateCategoryLabel(globalSettings: any) {
    if (globalSettings && globalSettings.securityCustAttrAbbr && this.grid && this.grid.api) {
      this.grid.api.getColumnDef("CustCat").headerName = globalSettings.securityCustAttrAbbr;
      this.grid.api.refreshHeader();
    }
  }

  load() {
    if (this.data) {
      if (this.grid && this.grid.api) {
        const gridData = this.buildHierarchy();
        this.grid.api.setGridOption('rowData', gridData);
        this.rowCount = this.getRowCount();
        this.setTotalPercent();
        this.finScore = this.data.finscore ? this.data.finscore.toString() : '--';
        this.setHeight();
      }
    }
  }

  private buildHierarchy() {
    let newGridData: any = [], md: any, mdChild: any;
    if (this.data.blendedSecurityModelAssociationsList) {
      const gridData = [].concat(this.data.blendedSecurityModelAssociationsList);


      if (gridData) {
        gridData.forEach((model: any) => {
          if (model.securityModelDTO && !model.securityModelDTO.isUIdeleted) {
            md = {
              securityModelId: model.securityModelDTO.securityModelId,
              securityModelName: model.securityModelDTO.securityModelName,
              securityModelDescription: model.securityModelDTO.securityModelDescription,
              modelPercent: model.securityModelDTO.modelPercent,
              customCategoryName: null,
              noSecurities: model.securityModelDTO.securityModelAllocationList.length
            };
            newGridData.push(md);

            const securities = model.securityModelDTO.securityModelAllocationList;
            securities.forEach((sec: any) => {
              mdChild = {
                securityId: sec.securityId,
                securityModelId: model.securityModelDTO.securityModelId,
                securityModelName: sec.securitySymbol,
                securityModelDescription: sec.securityDescription,
                targetPercentage: sec.targetPercentage,
                modelPercent: sec.targetPercentage,
                mdlPer: model.securityModelDTO.modelPercent,
                customCategoryName: sec.customCategoryName,
                acLevel4: sec.acLevel4,
                acLevel3: sec.acLevel3,
                acLevel2: sec.acLevel2,
                acLevel1: sec.acLevel1
              };
              newGridData.push(mdChild);
            });
          }
        });
      }
    }

    return newGridData;
  }

  onGridReady(params: any) {
    this.grid = params;
    this.getAndUpdateCategoryLabel();
    this.load();
  }

  getRowCount() {
    let rowcnt = 0;
    if (this.data && this.data.blendedSecurityModelAssociationsList && this.data.blendedSecurityModelAssociationsList.length !== 0) {
      rowcnt = this.data.blendedSecurityModelAssociationsList.filter((x: any) => x.securityModelDTO.isUIdeleted !== true).length
    }
    return rowcnt;
  }
  cancelDelete() {
    this.ctas.remove();
  }

  delete(deletedModel: any) {
    const listOfModels: any = this.data.blendedSecurityModelAssociationsList;
    for (let i = 0; i < listOfModels.length; i++) {
      if (listOfModels[i].securityModelDTO.securityModelId === deletedModel.securityModelId) {
        listOfModels[i].securityModelDTO.isUIdeleted = true;
        break;
      }
    }
    this.load();
    this.change.emit(true);
    if (!this.isUiTest) {
      window.setTimeout(() => {
        this.bmas.getGlobalSettings(this.data);
      });
    }
  }

  deleteAll() {
    const listOfModels: any = this.data.blendedSecurityModelAssociationsList;
    for (let i = 0; i < listOfModels.length; i++) {
      listOfModels[i].securityModelDTO.isUIdeleted = true;
    }
    this.load();
    this.change.emit(true);
    if (!this.isUiTest) {
      window.setTimeout(() => {
        this.bmas.getGlobalSettings(this.data);
      });
    }
  }


  private getModelPositions() {
    const modelPositions: any = {
      modelId: this.data.blendedSecurityModelId,
      modelName: this.data.blendedSecurityModelName
    };
    const positions: any = [];
    let item: any;
    const allocSec = this.bmas.getAllocationSecurities();
    allocSec.forEach((sec: any) => {
      item = {
        symbol: sec.securitySymbol ,
        targetPercentage: sec.weightedTarget
      };
      positions.push(item);
    });
    modelPositions.positions = positions;
    return modelPositions;
  }
  getFinMasonScore() {
    this.ats.trackClickEvent("lc_finmason");

    this.ies.getModelFinscore(this.getModelPositions()).subscribe((finScore: any) => {
      if (finScore.finscore && finScore.finscore.toString() !== '0') {
        this.finScore = finScore.finscore;
      } else {
        this.finScore = '--';
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'FinScore Not Available',
          detail: 'The model may be targeting an unrecognized security, e.g. custom, group, SMA, etc.'
        });
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'error',
        summary: 'FinScore Not Available',
        detail: 'The model may be targeting an unrecognized security, e.g. custom, group, SMA, etc.'
      });
    });
  }

  addModelsFromDropdown() {
    let modelDetailsReq: any;
    let listOfNewModels: Array<any> = [];
    let showDuplicateToast: boolean = false;
    let deletedIsBack: boolean = false;
    this.securityModelsList.forEach((model: any) => {
      const listOfModels: any = this.data.blendedSecurityModelAssociationsList;
      let isExists: boolean = false;
      for (let i = 0; i < listOfModels.length; i++) {
        if (listOfModels[i].securityModelDTO.securityModelId === model.value) {
          if (!listOfModels[i].securityModelDTO.isUIdeleted) {
            isExists = true;
            showDuplicateToast = true;
            break;
          } else {
            isExists = true;
            listOfModels[i].securityModelDTO.isUIdeleted = false;
            deletedIsBack = true;
          }
        }
      }
      if (!isExists) {
        listOfNewModels.push(model);
      }
    });

    if (showDuplicateToast) {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: "warn",
        summary: "",
        detail: "Security model(s) cannot be listed twice.",
      });
    }

    if (listOfNewModels.length === 0 && deletedIsBack) {
      this.load();
      this.change.emit(true);
      if (!this.isUiTest) {
        window.setTimeout(() => {
          this.bmas.getGlobalSettings(this.data);
        });
      }
    }

    let arrayOfAdded: Array<boolean> = [];
    listOfNewModels.forEach((model: any) => {
      modelDetailsReq = {
        modelId: model.value,
        type: 'Base',
        isDraft: false
      };
      this.ies.getModelDetailsForEditModel(modelDetailsReq).subscribe((data: any) => {
        if (data && data.approvedDTO) {
          const newModel: any = {
            securityModelDTO: data.approvedDTO
          };
          newModel.securityModelDTO.isNew = true;
          newModel.securityModelDTO.isUIdeleted = false;
          this.data.blendedSecurityModelAssociationsList.push(newModel);

          arrayOfAdded.push(true);
          if (arrayOfAdded.length === listOfNewModels.length) {
            this.load();
            this.change.emit(true);
            if (!this.isUiTest) {
              window.setTimeout(() => {
                this.bmas.getGlobalSettings(this.data);
              });
            }
          }
        }
      });
    });
    this.securityModelsList = [];
    if (this.securityModelsDropdown)
      this.securityModelsDropdown.clear();
  }

  getSecurityModelDropDownForBlended() {
    this.ies.getSecurityModelDropDownForBlended().subscribe((res: any) => {
      this.securityModelsListOriginal = res.items;
      this.getSecurityModelsFiltered('');
    });
  }

  getSecurityModelsFiltered(searchStr: string) {
    this.securityModelsDropdown && this.securityModelsDropdown.set(DropdownFilterComponent.getFilteredList(searchStr,this.securityModelsListOriginal
      .map((item: any) => ({
        name: item.securityModelName,
        value: item.securityModelId
      }))
    ));
  }

  onAddModelsChange(s: Array<any>) {
    this.securityModelsList = s;
  }

  onApplyTarget(params: any) {
  //  const newPercent = params.value ? params.value : 0;
  //  params.data.modelPercent = newPercent;

    const listOfModels: any = this.data.blendedSecurityModelAssociationsList;
    for (let i = 0; i < listOfModels.length; i++) {
      if (listOfModels[i].securityModelDTO.securityModelId === params.data.securityModelId) {
        listOfModels[i].securityModelDTO.modelPercent = params.data.modelPercent;
        break;
      }
    }
    this.load();
    this.change.emit(true);
    if (!this.isUiTest) {
      window.setTimeout(() => {
        this.bmas.getGlobalSettings(this.data);
      });
    }
  }


  @HostListener("window:resize")
  onResize() {
    setTimeout(() => {
      this.setTotalPercent();
    }, 200);
  }

  setTotalPercent() {
    let totalValue = 0;
    if (this.data && this.data.blendedSecurityModelAssociationsList && this.data.blendedSecurityModelAssociationsList.length !== 0) {
      this.data.blendedSecurityModelAssociationsList.forEach((bm: any) => {
        if (!bm.securityModelDTO.isUIdeleted) {
          totalValue += Number(bm.securityModelDTO.modelPercent);
        }
      });
    }
    this.totalPercent = Number(totalValue.toFixed(1));
    let agridHeaderTargets = document.querySelectorAll('#edit-blended-model-allocation-grid .ag-header-cell');
    let totalWidthLeft = 0;
    if(agridHeaderTargets && agridHeaderTargets.length > 0) {
      let targetElIndex: any = 4;
      agridHeaderTargets.forEach((targetEl,index)=>{
        if(targetEl.classList.contains('editHeaderModelPercent')) {
          targetElIndex = index;
        }
      });
      for(let i =0; i< targetElIndex;i++) {
        let elPos = agridHeaderTargets[i].getBoundingClientRect();
        totalWidthLeft+= elPos.width;
      }

      const headerTarget = document.querySelector('.editHeaderModelPercent');
      if (headerTarget) {
        const pos = headerTarget.getBoundingClientRect();

        const totalValEl: any = document.querySelector('#edit-blended-model-allocation-grid-totalper');
        if (totalValEl) {
          totalValEl.style.left = totalWidthLeft + 'px';
          totalValEl.style.width = pos.width + 'px';
          totalValEl.innerHTML = totalValue.toFixed(1);
          this.bmas.setTotalPercentForBlended(totalValue.toFixed(1));
        }
        const finscoreEl: any = document.querySelector('#edit-secallocation-finscore-totalper');
        if (finscoreEl) {
          finscoreEl.style.left = totalWidthLeft + 'px';
          finscoreEl.style.width = pos.width + 'px';
        }
      }
    }
  }
  ngOnDestroy(): void {
    if (this.globSetSub) {
      this.globSetSub.unsubscribe();
    }
  }
  onModelAllocationsGridCellClicked(event: CellClickedEvent) {
    if(event.column.getColId() === 'securityModelName') {
      if(event.node.isExpandable() && event.node.expanded) {
        event.node.setExpanded(false);
      } else if (event.node.isExpandable() && !event.node.expanded) {
        event.node.setExpanded(true);
      }
      this.setHeight();
    }
  }
}
